::ng-deep app-streams-toolbar{flex:1 0 auto}::ng-deep app-streams-toolbar .toolbar-separator{width:1px;background:#0000001f}
/*# sourceMappingURL=streams-toolbar.component-SWJFZ2ZX.css.map */
